// extracted by mini-css-extract-plugin
export default {"center":"vESyAc","opacityLayer":"U6BsE3"};